import React from "react";
import styled from "styled-components";

import { TestWrapper } from "@ui/Atoms/TestWrapper";
import { NormalizedList } from "@ui/Atoms/List";

const ChildWrapperComponent = (props: {
  className?: string;
  testId?: string;
  children: React.ReactNode;
}): React.ReactElement => (
  <TestWrapper testId={props.testId}>
    <ChildWrapper className={props.className}>{props.children}</ChildWrapper>
  </TestWrapper>
);

const ListComponent = (props: {
  className?: string;
  testId?: string;
  children: React.ReactNode;
}): React.ReactElement => (
  <TestWrapper testId={props.testId}>
    <NormalizedList className={props.className}>
      {props.children}
    </NormalizedList>
  </TestWrapper>
);

const ListItemComponent = (props: {
  className?: string;
  testId?: string;
  children: React.ReactNode;
  "data-hj-allow"?: boolean;
}): React.ReactElement => (
  <TestWrapper testId={props.testId}>
    <StyledListItem
      className={props.className}
      data-hj-allow={props["data-hj-allow"]}
    >
      {props.children}
    </StyledListItem>
  </TestWrapper>
);

export { ChildWrapperComponent, ListComponent, ListItemComponent };

const ChildWrapper = styled.div`
  padding: 0 0 ${props => props.theme.margins.base_x1_5};
  border-bottom: 1px solid ${props => props.theme.palette.grey100};

  & + & {
    margin-top: ${props => props.theme.margins.base_x2};
  }
`;

const StyledListItem = styled.li`
  margin-top: ${props => props.theme.margins.base_x1_5};
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: ${props => props.theme.margins.base_x2} 1fr;
  gap: 0px ${props => props.theme.margins.base_x3};

  &:first-child {
    margin-top: 0;
  }
`;
